export const getClientSideID = () => process.env.VITE_CLIENT_SIDE_ID;
